import React from 'react';
import GeneralEditWizzardBase from '../../GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditAddressWindowDescription from '../../../Contents/Sales/AddressAdmin/EditAddressWindowDescription';
import AddressItem from '../../../Domain/AddressItem';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import AddressService from '../../../Services/AddressService';
import ErrorMessage from '../../ErrorMessage';
import FigmaButton from '../../FigmaButton';

class AddressBox extends React.Component {
  static defaultProps = {
    addressId: 0,
    className: '',
    UpdateRecord: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      address: null,
      loading: true,
    };
    this.state = {
      shownPanel: ShownPanelsEnum.None,
    };
    this.showPanel = this.showPanel.bind(this);
  }

  componentDidMount() {
    this.populateData();
  }

  componentDidUpdate(nextProps) {
    if (nextProps.addressId !== this.props.addressId) {
      this.populateData();
    }
  }

  populateData() {
    AddressService.GetAddressById(this.props.addressId)
      .then((result) => {
        let converted = new AddressItem(result);
        this.setState({ address: converted });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('AB50', error);
      });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.address}
            windowDescription={EditAddressWindowDescription}
            errorCode='AB61'
            clickOnSave={() => {
              this.populateData();
              this.props.UpdateRecord(true);
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          />
        )}
      </div>
    );
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButton
          label='Edit Address'
          className='buttontotop'
          type={ButtonTypeEnum.NormalIconLeft}
          color={ButtonColorsEnum.Common}
          iconPosition={IconPositionEnum.None}
          onClick={(e) => {
            e.preventDefault();
            this.showPanel(ShownPanelsEnum.EditItem);
          }}
        />
        {this.renderPanels()}
      </div>
    );
  }

  render() {
    if (!this.state.address) return null;
    return (
      <div className={this.props.className + ' ds-addressbox border container-fluid'}>
        <div className='row'>
          <div className='col-6'>
            <div className=' text-left'>
              <div>AddressId: {this.state.address.AddressId}</div>
              <div className={this.state.address.Name === '' ? 'text-red' : ''}>Name: {this.state.address.Name}</div>
              <div className={this.state.address.Line1 === '' ? 'text-red' : ''}>
                Street: {this.state.address.Line1}
              </div>
              <div className={this.state.address.City === '' ? 'text-red' : ''}>City: {this.state.address.City}</div>
              <div className={this.state.address.PostalCode === '' ? 'text-red' : ''}>
                Postal Code: {this.state.address.PostalCode}
              </div>
              <div className={this.state.address.State === '' ? 'text-red' : ''}>State: {this.state.address.State}</div>
              <div className={this.state.address.CountryName === '' ? 'text-red' : ''}>
                Country: {this.state.address.CountryName}
              </div>
              <div>Address Type: {this.state.address.TypeText}</div>
            </div>
          </div>
          <div className='col-6 text-right p-1 position-relative'>{this.renderButtonsAndPanels()}</div>
        </div>
      </div>
    );
  }
}

export default AddressBox;
